import script from "./UserFormTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./UserFormTemplate.vue?vue&type=script&setup=true&lang=js"

import "./UserFormTemplate.vue?vue&type=style&index=0&id=6d09898a&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d09898a"]])

export default __exports__